

















































import * as _ from "lodash";
import { Component, Vue, Prop } from "vue-property-decorator";
import { getGuanchazhibiaoAndBiaoqian } from "@/request/idr";
import TongueContent from "./tongue-content.vue";
@Component({
  components: {
    TongueContent,
  },
})
export default class IdrTongueBiduiList extends Vue {
  private tongueId: any;
  private tongue: any = {};
  private ifShowBiaozhu: boolean = false;
  private selectedTongues: any[] = [];
  /**
   * @description 返回图片列表
   */
  private backList() {
    this.$router.push({
      path: "/main/idr/tongue-list",
    });
  }
  /**
   * @description 获取单个舌象的详情
   */
  private fetchTongueDetail(id) {
    const params: any = {
      params: {
        tongue_id: id,
      },
    };
    getGuanchazhibiaoAndBiaoqian(this, params).then((data: any) => {
      this.tongue = data;
      this.selectedTongues.push(this.tongue);
    });
  }
  /**
   * @description 切换选中的舌图
   */
  private triggerSelectedTongue(tongue) {
    const index = _.findIndex(this.selectedTongues, (i: any) => {
      return i.tongue_id === tongue.tongue_id;
    });
    if (index !== -1) {
      this.selectedTongues.splice(index, 1);
    } else {
      if (this.selectedTongues.length >= 4) {
        this.$message.warning("最多只能选择4张舌图");
        return;
      }
      this.selectedTongues = _.uniqBy(
        [...this.selectedTongues, tongue],
        "tongue_id"
      );
    }
  }
  /**
   * @description 删除一个已选的舌图
   */
  private deleteTongue(tongue) {
    const index = _.findIndex(this.selectedTongues, (i: any) => {
      return i.tongue_id === tongue.tongue_id;
    });
    this.selectedTongues.splice(index, 1);
  }
  /**
   * @description 开始比对
   */
  private startBidui() {
    // console.log(this.selectedTongues);
    if (this.selectedTongues.length <= 1) {
      this.$message.warning("请至少选择两张舌图");
      return;
    }
    localStorage.setItem(
      "selectedTongues",
      JSON.stringify(this.selectedTongues)
    );
    this.$router.push({
      path: "/main/idr/tongue-bidui-detail",
    });
  }
  /**
   * @description 初始化
   */
  private beforeMount() {
    if (this.$route.query) {
      this.tongueId = this.$route.query.tongue_id;
      if (this.tongueId) {
        this.fetchTongueDetail(this.tongueId);
      }
    }
  }
  /**
   * @description 从详情页返回重新选择时加载已选
   */
  private beforeRouteEnter(to, from, next) {
    if (from.path === "/main/idr/tongue-bidui-detail") {
      const selectedTongues = localStorage.getItem("selectedTongues");
      if (selectedTongues) {
        next((vm: any) => {
          vm.selectedTongues = JSON.parse(selectedTongues);
        });
      } else {
        next();
      }
    } else {
      next();
    }
  }
}
